var map = {
	"./circle_black.svg": 940,
	"./circle_blue.svg": 941,
	"./ellipse_black.svg": 942,
	"./france.svg": 261,
	"./highlighted_yellow.svg": 943,
	"./icons/_info.svg": 944,
	"./icons/add_prod.svg": 264,
	"./icons/add_prodOLD.svg": 945,
	"./icons/ask.svg": 946,
	"./icons/facebook.svg": 37,
	"./icons/hatchef.svg": 50,
	"./icons/icone/_info.svg": 947,
	"./icons/icone/hatchef.svg": 948,
	"./icons/icone/info.svg": 949,
	"./icons/icone/play.svg": 950,
	"./icons/icone/plus.svg": 951,
	"./icons/icone/specs.svg": 952,
	"./icons/icone/world.svg": 953,
	"./icons/index-icon-bookmark.svg": 954,
	"./icons/index-icon.svg": 394,
	"./icons/info.svg": 51,
	"./icons/markers-SVG/ask.svg": 955,
	"./icons/markers-SVG/info.svg": 956,
	"./icons/markers-SVG/list.svg": 957,
	"./icons/markers-SVG/recipe.svg": 958,
	"./icons/markers-SVG/web.svg": 959,
	"./icons/play.svg": 46,
	"./icons/play_ip.svg": 960,
	"./icons/plus.svg": 48,
	"./icons/promo.svg": 45,
	"./icons/promo2.svg": 961,
	"./icons/promo3.svg": 962,
	"./icons/promo_10.svg": 963,
	"./icons/promo_classic.svg": 964,
	"./icons/remove_prod.svg": 265,
	"./icons/remove_prodOLD.svg": 965,
	"./icons/shop_list.svg": 266,
	"./icons/specs.svg": 44,
	"./icons/whatsapp.svg": 38,
	"./icons/world.svg": 26
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939;